import yup from 'src/libs/yup';

const BeneficiaryUserFilterSchema = yup.object().shape({
  name: yup.string().label('Nome'),
  email: yup.string().label('E-mail'),
  status: yup.string().nullable().label('Status'),
});

export default BeneficiaryUserFilterSchema;
